import { useFilterOptionsBase, DashboardFilterOptionsResponse } from './useFilterOptionsBase';

/**
 * Hook for fetching dashboard filter options.
 * Returns available users, projects, statuses, and admin status for the Dashboard page.
 */
export const useDashboardFilterOptions = () => {
  const result = useFilterOptionsBase<DashboardFilterOptionsResponse>('/dashboard/filterOptions');

  return {
    availableUsers: result.availableUsers,
    availableProjects: result.availableProjects,
    availableStatuses: result.rawResponse?.availableStatuses || [],
    availableLabels: result.rawResponse?.availableLabels || [],
    isAdmin: result.isAdmin,
    loading: result.loading,
    error: result.error,
    refresh: result.refresh,
  };
};
